import { baseUrl } from "./baseUrl";

import buildUrl from "../utils/buildUrl";

export const getTenantsRoute = () =>
  buildUrl({
    url: `${baseUrl}/dict-api/tenants`,
  });

export const getTenantByIdRoute = (tenantId) =>
  buildUrl({
    url: `${baseUrl}/dict-api/tenants/${tenantId}`,
  });
